// src/mocks/handlers/analyticsV2.handlers.js
import * as data from '../data/analyticsV2.demo';

// Detect period from startDate/endDate params (set by getDateRanges())
// day  ≤ 1 day diff | week ≤ 8 days | month > 8 days
const detectPeriod = (config) => {
    const start = config?.params?.startDate;
    const end   = config?.params?.endDate;
    if (!start || !end) return 'week';
    const diffDays = Math.round((new Date(end) - new Date(start)) / 86400000);
    if (diffDays <= 1) return 'day';
    if (diffDays <= 8) return 'week';
    return 'month';
};

export const getDailySalesProgress = async () => data.dailySalesProgress;

export const getSalesSummary = async (config) => {
    const period = detectPeriod(config);
    return period === 'month' ? data.salesSummaryMonth : data.salesSummaryWeek;
};

export const getSalesByCategory = async (config) => {
    const period = detectPeriod(config);
    if (period === 'month') return data.salesByCategoryMonth;
    if (period === 'week')  return data.salesByCategoryWeek;
    return data.salesByCategoryDay;
};

export const getPaymentMethods = async (config) => {
    const period = detectPeriod(config);
    if (period === 'month') return data.paymentMethodsMonth;
    if (period === 'week')  return data.paymentMethodsWeek;
    return data.paymentMethodsDay;
};

export const getProfitAnalysis = async () => data.profitAnalysis;
